import { render, staticRenderFns } from "./BatchApprove.pug?vue&type=template&id=48d4fd80&scoped=true&lang=pug&"
import script from "./BatchApprove.vue?vue&type=script&lang=js&"
export * from "./BatchApprove.vue?vue&type=script&lang=js&"
import style0 from "./BatchApprove.scss?vue&type=style&index=0&id=48d4fd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d4fd80",
  null
  
)

export default component.exports